import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createCategory,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  updateAssignCity,
  getAllCity,
  updateCity,
  getBnBCities,
} from '../../helper/backend_helper';
import InfoTooltip from '../InfoTooltip';

const UpdateAssignCity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState(userData?.cityName);
  const [cities, setCities] = useState(userData?.cities);
  const [bnbcities, setBnbCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getAllCity();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function fetchBnBCities() {
    try {
      const usersResponse = await getBnBCities();
      setBnbCities(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchBnBCities();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'City Name is required',
        });
        setLoading(false);
        return;
      }

      if (cities.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Cities is required',
        });
        setLoading(false);
        return;
      }

      // Prepare headers for multipart form data

      const Categorydata = {
        cityName: name.trim(),
        cities,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateAssignCity(userData?._id, Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'City updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update City </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update City</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>BnB Location <InfoTooltip title="The BnB city that guest content (categories, places) will be drawn from for the cities you assign below." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={name}
                  // label="BnB"
                  onChange={(e) => setName(e.target.value)}
                >
                  {bnbcities?.map((user) => (
                    <MenuItem key={user._id} value={user.name}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={2} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Cities <InfoTooltip title="Cities mapped to the selected BnB location so their guests see that location's content." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={cities}
                onChange={(e) => setCities(e.target.value)}
                renderValue={(selected) => selected.join(', ')}
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.name}>
                    <Checkbox checked={cities.indexOf(user.name) > -1} />
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateAssignCity;
